module.exports = __webpack_public_path__ + "img/gifiqr-vendlet-banner-forsiden.9812af10.jpg";